"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLOR = void 0;
exports.COLOR = Object.freeze({
    SURFACE: Object.freeze({
        ACCENT_1: Object.freeze({
            DEFAULT: '#f27e6c',
            HOVER: '#e06452',
            SUBTLE: '#f37f6e19',
            SUBTLE_HOVER: '#f37f6e4c',
        }),
        ACCENT_2: Object.freeze({
            DEFAULT: '#fbbc65',
            HOVER: '#e0a758',
            SUBTLE: '#fbbc6533',
            SUBTLE_HOVER: '#fbbc654c',
        }),
        AI: Object.freeze({
            DEFAULT: '#7367d9',
            HOVER: '#9592e7',
            SUBTLE: '#7367d919',
            SUBTLE_HOVER: '#7367d94c',
        }),
        DEFAULT: Object.freeze({
            DEFAULT: '#cdd1d4',
            DISABLED: '#e5e6e8',
            INVERSE: '#ffffff',
        }),
        ERROR: Object.freeze({
            DEFAULT: '#c05343',
            HOVER: '#e06452',
            DEFAULT_SUBTLE: '#e8292f11',
            DEFAULT_SUBTLE_HOVER: '#e8292f33',
        }),
        PAGE: Object.freeze({
            DEFAULT: '#ffffff',
            OVERLAY: '#2425284c',
            BASE: Object.freeze({
                NEUTRAL: '#f1f2f2',
                WARM: '#fbbc6523',
            }),
            DARK: Object.freeze({
                NEUTRAL: '#4a4e54',
            }),
        }),
        PRIMARY: Object.freeze({
            DEFAULT: '#257d69',
            HOVER: '#25a186',
            SUBTLE: '#1c605314',
            SUBTLE_HOVER: '#1c605333',
        }),
        SECONDARY: Object.freeze({
            DEFAULT: '#537087',
            HOVER: '#64859a',
            DARK: '#035C84',
            SUBTLE: '#61819619',
            SUBTLE_HOVER: '#61819633',
        }),
        SUCCESS: Object.freeze({
            DEFAULT: '#257d69',
            HOVER: '#25a186',
            SUBTLE: '#1c605314',
            SUBTLE_HOVER: '#1c605333',
        }),
        WARNING: Object.freeze({
            DEFAULT: '#e55a11',
            HOVER: '#f4741b',
            SUBTLE: '#f4741b19',
            SUBTLE_HOVER: '#f4741b33',
        }),
    }),
    TEXT: Object.freeze({
        ACCENT_1: Object.freeze({
            DEFAULT: '#f27e6c',
            HOVER: '#e06452',
        }),
        ACCENT_2: Object.freeze({
            DEFAULT: '#a87c3f',
            HOVER: '#c4914c',
        }),
        AI: Object.freeze({
            DEFAULT: '#7367d9',
            HOVER: '#9592e7',
        }),
        DEFAULT: Object.freeze({
            BODY: '#4a4e54',
            CAPTION: '#646c76',
            DISABLED: '#cdd1d4',
            HEADING: '#242528',
            INVERSE: '#ffffff',
            PLACEHOLDER: '#808890',
            ON_DISABLED: '#aab0b6',
        }),
        ERROR: Object.freeze({
            DEFAULT: '#9f4335',
            HOVER: '#c05343',
        }),
        PRIMARY: Object.freeze({
            DEFAULT: '#257d69',
            HOVER: '#25a186',
        }),
        SECONDARY: Object.freeze({
            DEFAULT: '#537087',
            HOVER: '#64859a',
        }),
        SUCCESS: Object.freeze({
            DEFAULT: '#257d69',
            HOVER: '#25a186',
        }),
        WARNING: Object.freeze({
            DEFAULT: '#e55a11',
            HOVER: '#f4741b',
        }),
    }),
    ICON: Object.freeze({
        ACCENT_1: Object.freeze({
            DEFAULT: '#f27e6c',
            HOVER: '#e06452',
        }),
        ACCENT_2: Object.freeze({
            DEFAULT: '#a87c3f',
            HOVER: '#c4914c',
        }),
        AI: Object.freeze({
            DEFAULT: '#7367d9',
            HOVER: '#9592e7',
        }),
        DEFAULT: Object.freeze({
            BODY: '#4a4e54',
            CAPTION: '#646c76',
            DISABLED: '#cdd1d4',
            HEADING: '#242528',
            INVERSE: '#ffffff',
            PLACEHOLDER: '#808890',
            ON_DISABLED: '#aab0b6',
        }),
        ERROR: Object.freeze({
            DEFAULT: '#9f4335',
            HOVER: '#c05343',
        }),
        PRIMARY: Object.freeze({
            DEFAULT: '#257d69',
            HOVER: '#25a186',
        }),
        SECONDARY: Object.freeze({
            DEFAULT: '#537087',
            HOVER: '#64859a',
        }),
        SUCCESS: Object.freeze({
            DEFAULT: '#257d69',
            HOVER: '#25a186',
        }),
        WARNING: Object.freeze({
            DEFAULT: '#e55a11',
            HOVER: '#f4741b',
        }),
    }),
    BORDER: Object.freeze({
        ACCENT_1: Object.freeze({
            DEFAULT: '#f27e6c',
            HOVER: '#e06452',
            SUBTLE: '#f48f804c',
            SUBTLE_HOVER: '#f27e6c',
        }),
        ACCENT_2: Object.freeze({
            DEFAULT: '#fbbc65',
            HOVER: '#e0a758',
            SUBTLE: '#fbbc654c',
            SUBTLE_HOVER: '#fbbc65',
        }),
        AI: Object.freeze({
            DEFAULT: '#7367d9',
            HOVER: '#9592e7',
            SUBTLE: '#7367d94c',
            SUBTLEHOVER: '#7367d9',
        }),
        DEFAULT: Object.freeze({
            DEFAULT: '#e5e6e8',
            DISABLED: '#e5e6e8',
            INVERSE: '#ffffff',
            STRONG: '#cdd1d4',
        }),
        ERROR: Object.freeze({
            DEFAULT: '#9f4335',
            HOVER: '#c05343',
            SUBTLE: '#a043354c',
        }),
        ERROR_SUBTLE: Object.freeze({
            HOVER: '#9f4335',
        }),
        PRIMARY: Object.freeze({
            DEFAULT: '#257d69',
            HOVER: '#25a186',
            SUBTLE: '#1c60534c',
        }),
        PRIMARY_SUBTLE: Object.freeze({
            HOVER: '#257d69',
        }),
        SECONDARY: Object.freeze({
            DEFAULT: '#537087',
            HOVER: '#64859a',
            SUBTLE: '#6181964c',
        }),
        SECONDARY_SUBTLE: Object.freeze({
            HOVER: '#537087',
        }),
        SUCCESS: Object.freeze({
            DEFAULT: '#257d69',
            HOVER: '#25a186',
            SUBTLE: '#1c60534c',
            SUBTLE_HOVER: '#257d69',
        }),
        WARNING: Object.freeze({
            DEFAULT: '#e55a11',
            HOVER: '#f4741b',
            SUBTLE: '#f4741b4c',
            SUBTLE_HOVER: '#e55a11',
        }),
    }),
});
